const breakpoints = {
  mobile: 375,
  tablet: 768
};
const backgroundColorMap = {
  ocean40: "night",
  sun60: "moss",
  lava60: "zapier",
  white: "neutral100",
  neutral100: "neutral100",
  zapier: "zapier",
  night: "night",
  moss: "moss",
  neutral800: "neutral800"
};

export { backgroundColorMap, breakpoints };
//# sourceMappingURL=constants.es.js.map
